import { JsonObject } from 'json2typescript';
import GoodsOptionType from './GoodsOptionType';

@JsonObject('GoodsDetail')
export default class GoodsDetail {
  constructor() {
    this.goodsCode = '';
    this.goodsTitle = '';
    this.overview = '';
    this.periodStart = '';
    this.periodEnd = '';
    this.canBuy = false;
    this.fee = 0;
    this.thumbnail = '';
    this.alternativeText = '';
    this.goodsOptionTypes = new Array<GoodsOptionType>();
  }

  public goodsCodeOrg: string;

  public goodsCode: string;

  public goodsTitle: string;

  public overview: string;

  public periodStart: string;

  public periodEnd: string;

  public canBuy: boolean;

  public fee: number;

  public thumbnail: string;

  public alternativeText: string;

  public goodsOptionTypes: Array<GoodsOptionType>;
}
